import type { NavigateOptions as OriginalNavigateOptions } from "react-router";
import useNavigateMBC, { type MbcOptions } from "./useNavigateMBC";
import useNavigateWEB from "./useNavigateWEB";
import { useFlytHeader } from "~/shared/components/flyt";
import mbc from "~/shared/functions/mbc";

export type NavigateOptions = OriginalNavigateOptions & MbcOptions;

export interface UseNavigateFunction {
	(link: string, options?: NavigateOptions): void;
	(delta: number, options?: NavigateOptions): void;
	navTitleHeader?: string;
}

export function useNavigate(): UseNavigateFunction {
	const flytHeader = useFlytHeader();
	const webNavigate = useNavigateWEB();
	const mbcNavigate = useNavigateMBC();

	return (link: string | number, options?: NavigateOptions) => {
		if (mbc.isNative()) {
			// Bruk navigationBarTitle fra options hvis den er tilgjengelig, ellers bruker vi flytHeader
			const navigationBarTitle = options?.navigationBarTitle ?? flytHeader.navigationBarTitle;
			const optionsWithTitle = navigationBarTitle !== undefined ? { ...options, navigationBarTitle } : options;
			mbcNavigate(link, optionsWithTitle);
		} else {
			webNavigate(link, options);
		}
	};
}
